import { LazyExoticComponent, FunctionComponent } from "react"

type IconSource = any

export type ModalRouteNode = {
  name: string
  getTitle: () => string
  component: LazyExoticComponent<FunctionComponent<any>>
}

export enum MenuType {
  // 工作台 - 默认菜单
  Default = "default",

  // 工作台 - 应用中心
  Apps = "apps",

  // 管理中心 - 核心功能
  Admin = "admin",

  // 管理中心 - 应用管理
  AdminApps = "adminApps",
}

type GroupConfig<T> = T | readonly [T, string]

export type RouteMenuGroupConfig = () =>
  | GroupConfig<MenuType.Apps>
  | GroupConfig<MenuType.Admin>
  | GroupConfig<MenuType.Default>
  | GroupConfig<MenuType.AdminApps>

export type RouteMenuConfig = {
  /**
   * 指定 MenuType 以及可选的菜单组名称
   */
  group: RouteMenuGroupConfig
  /**
   * 菜单组名称旁边的 icon
   */
  icon?: IconSource
}

export type RouteConfig = {
  // 考虑向后兼容, 暂时设为 optional
  name?: string

  // relative path here
  path: string
  getTitle: () => string
  component: LazyExoticComponent<FunctionComponent<any>>

  /**
   * 路由的菜单定义
   * 应使用最新的菜单定义
   *
   * @deprecated
   */
  menu?: RouteMenuConfig

  /*
   * 按后端返回的权限筛选，满足其中一个则为有权限
   *   requirePermissions?: PermissionNameEnum[]
   */

  /*
   * 按角色筛选，优先级：requireRoles > requirePermissions
   *   requireRoles?: RoleEnum[]
   */

  /**
   * 用 school id 指定开放的学校
   *
   * WARNING: 在有插件商店管理插件开关的情况下，不应当用到这个字段，
   * 只用于特殊时期和特殊情况下的 hack 需求
   */
  requireSchools?: number[]

  // 自定义字段
  customMeta?: { [key: string]: any }

  subRoutes?: RouteConfig[]

  /*
   * 路由所属菜单组定义，会用于菜单的懒加载
   * 侧边栏的菜单会依据当前路由配置的最后一个 module 匹配展示
   */
  module?: string[]

  /*
   * 注册该路由需要的模块名称
   * 设置后，只有学校开启了该模块，路由才会被注册
   */
  //   requireModules?: (ModuleEnum | PluginEnum)[]
}

export type RouteNode = Omit<RouteConfig, "subRoutes"> & {
  exact?: boolean
  parentPath?: string
  subRoutes?: RouteNode[]
}

export type RouteParams = {
  [key: string]: string | string[] | number | number[] | boolean | undefined
}

export type RouteParamsList = { [key: string]: RouteParams | null }

export const MODAL_QUERY_NAMESPACE = 'modalQuery'

export interface Query {
  [key: string]: any
}

export enum ModalMode {
  Push = 'push',
  Replace = 'replace',
}